import { createSequencedKeystoreAtom } from '@exodus/atoms'

// Path used in mobile. Using the same to avoid migration
const STORAGE_SEED_BACKUPS_KEY_PREFIX = `wallet:v3:seed-backups:`

const createLocalSeedPrivateBackupsAtom = ({ keystore }) => {
  return createSequencedKeystoreAtom({
    keystore,
    config: {
      key: STORAGE_SEED_BACKUPS_KEY_PREFIX,
      separator: ':',
      defaultValue: [],
      isSoleWriter: true,
    },
  })
}

export default createLocalSeedPrivateBackupsAtom
